export default __webpack_public_path__ + "static/media/151-ceremonial.ec0f5402.png";